import { useState } from 'react';
import axios from 'axios';
import { analyticsEventSend } from 'src/utils/analytics/analyticsEventSend';

export const useCreateSkill = () => {
  const [skill, setSkill] = useState();
  const [loadingSkill, setLoadingSkill] = useState<boolean>();

  const createSkill = async (
    selectedSkill: string,
    level: string,
    attitude: string,
    category: string
  ) => {
    if (loadingSkill) return;

    try {
      setLoadingSkill(true);
      const { data } = await axios.post('api/employee-skills/my', {
        id: selectedSkill,
        level: { value: level },
        attitude: { value: attitude },
        category: { value: category },
      });
      data && setSkill(data);
      analyticsEventSend('New skill request posted');
    } catch (err) {
      console.error(err);
    } finally {
      setLoadingSkill(false);
    }
  };

  return { skill, loadingSkill, createSkill };
};
